import { render } from "./VisitorAdultsTable.vue?vue&type=template&id=a8533e48"
import script from "./VisitorAdultsTable.vue?vue&type=script&lang=js"
export * from "./VisitorAdultsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__